import { unwrap, type SagotApi } from "@sagot/api-client";
import { REPORT_STALE_MS } from "./report-constants";
import { serviceKeys } from "../service-keys";
import type { ReportName, StatsDimension } from "./report-types";

/** What one read of a report asks for: the report, its breakdown and the period (`compare` adds the previous period's figures). */
export interface ReportSpec {
  report: ReportName;
  dimension: StatsDimension;
  from: string;
  to: string;
  compare: boolean;
}

/** The query one report read shares between the tabs (hooks) and the summary export (`fetchQuery`), so both hit the same cache entry. */
export function reportQuery(api: SagotApi, ws: string, spec: ReportSpec) {
  const { report, dimension, from, to, compare } = spec;
  return {
    queryKey: serviceKeys.report(ws, report, { dimension, from, to, compare }),
    staleTime: REPORT_STALE_MS,
    queryFn: ({ signal }: { signal: AbortSignal }) => unwrap(api.GET("/v1/service-reports/{report}", { params: { path: { report }, query: { from, to, dimension, compare } }, signal })),
  };
}
